module.exports = __webpack_public_path__ + "./img/logoParadigma.d31cc84f624bad16c4a56b64fee11a60.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/logoParadigma.png
// module id = ./public/img/logoParadigma.png
// module chunks = 0